const ELCA_WHERE_TO_FIND_US_PHONE_CONTACT_LOG = '[ElcaWhereToFindUsPhoneContact]';

$(document).ready(function () {
    geoLocalization();

});

function geoLocalization() {
    if (findSessionCookies()) {
        var contactPhone = sessionStorage['ContactPhone'];
        addCountryContacttoMainMenu(contactPhone);
        addCountryContacttoMobileMenu(contactPhone);
    }
    else {
        $.getJSON('https://api.ipify.org?format=json',
            function (data) {
                $.getJSON('/Sitefinity/Public/Services/GeoLocation/GeoLocation.svc/' + data.ip,
                    function () {
                    })
                    .done(function (userIpCountry) {
                        var jsonParse = JSON.parse(userIpCountry);

                        if (jsonParse.ErrorMessage) {
                            console.error(ELCA_WHERE_TO_FIND_US_PHONE_CONTACT_LOG, 'Cannot be able to complete geoLocalization');// eslint-disable-line no-console
                        }
 else {
                            searchCountryContact(jsonParse.Country);
                            return userIpCountry;
                        }

                    })
                    .fail(function () {
                        console.error(ELCA_WHERE_TO_FIND_US_PHONE_CONTACT_LOG, 'GeoLocalization failed');// eslint-disable-line no-console
                    });
            });
    }


}

function findSessionCookies() {
    if (sessionStorage['ContactPhone'] != undefined && sessionStorage['ContactPhone'] != '') {
        return true;
    }
    else {
        return false;
    }


}

function searchCountryContact(country) {
    var options = {
        url: '/elcawheretofindus/searchContactCountryPhone',
        data: 'country=' + country,
        async: true,
        type: 'PUT',
        success: function (result) {
            if (result != '' && result != null) {
                sessionStorage['ContactPhone'] = result;
                addCountryContacttoMainMenu(result);
                addCountryContacttoMobileMenu(result);
            }
        },
        error: function () {
            var message = 'Error loading the phone number for active country in menu for ElcaWhereToFindUsPhoneContact';
            console.error(ELCA_WHERE_TO_FIND_US_PHONE_CONTACT_LOG, message);// eslint-disable-line no-console
        }
    };
    return $.ajax(options);

}

function addCountryContacttoMainMenu(result) {
    if ($('#mi-corpo-contactphone-number').text() != result) {
        $('#mi-corpo-contactphone-number').append(result);
        $('#mi-corpo-header-menu-item-contactphone').removeClass('display-none');
    }

}

function addCountryContacttoMobileMenu(result) {
    if ($('#mi-corpo-mobile-geocountrycontact').text() != result) {
        var contactPhraseNode = $('#mi-mobile-geocountrycontactphrase');
        //var contactPhraseNode = $("#responsiveMenu");
        var ele = document.createElement('a');
        ele.className = 'mi-corpo-mobile-geocountrycontact';
        ele.id = 'mi-corpo-mobile-geocountrycontact';
        ele.href = 'tel:' + result;
        ele.innerHTML = result;
        contactPhraseNode.append(ele);
    }
}
